import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://staging.mynirva.com/api';

/**
 * Base host for the dashboard (no trailing slash).
 * Dashboard routes live under <DASHBOARD_URL>/dashboard/...
 */
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || 'https://staging.mynirva.com';

export const GHL_FORM_URLS = {
  yourJourney: 'https://api.leadconnectorhq.com/widget/form/NHj0RiZdH3h95Y8JFmzv',
  bookConsultation:
    'https://api.leadconnectorhq.com/widget/form/7L5gRMRzVieOXA4UqoUX?notrack=true&separateDialCode=true',
};

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
